import { useState } from "react";
import { CloseIcon, MenuIcon } from "./Icons";

const navigation = [
  { href: "#layanan", label: "Layanan" },
  { href: "#karya", label: "Karya" },
  { href: "#cara-kerja", label: "Cara Kerja" },
  { href: "#tentang", label: "Tentang" },
] as const;

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <a className="wordmark" href="#top" aria-label="Morolab, kembali ke atas" onClick={closeMenu}>
          MOROLAB
        </a>

        <button
          aria-controls="primary-navigation"
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? "Tutup menu" : "Buka menu"}
          className="menu-toggle"
          onClick={() => setIsMenuOpen((currentValue) => !currentValue)}
          type="button"
        >
          {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        <nav
          className={isMenuOpen ? "primary-navigation is-open" : "primary-navigation"}
          id="primary-navigation"
          aria-label="Navigasi utama"
        >
          {navigation.map((item) => (
            <a href={item.href} key={item.href} onClick={closeMenu}>
              {item.label}
            </a>
          ))}
          <a className="button button-primary header-cta" href="#order" onClick={closeMenu}>
            Mulai Proyek
          </a>
        </nav>
      </div>
    </header>
  );
}
